import { Briefcase } from 'lucide-react';

export function PortalSignedOutPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="mx-auto mb-4 p-3 bg-blue-100 rounded-full w-fit">
          <Briefcase className="h-8 w-8 text-blue-600" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Signed Out</h1>
        <p className="text-gray-600">
          You have been signed out of the client portal.
        </p>
        <p className="text-sm text-gray-500 mt-2">
          Use the link from your email to sign back in.
        </p>
      </div>
    </div>
  );
}
